import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import FormUtils from './FormUtils';
const formUtils: { [key: string]: FormUtils } = {};

export const getFormUtils = (form) => {
  if (formUtils[form.ref] && formUtils[form.ref].getModel().lang === form.lang) {
    return formUtils[form.ref];
  }
  const fu = new FormUtils(form);
  formUtils[form.ref] = fu;
  return fu;
};

export const updateFormUtils = (forms: FormInterface[]) => {
  for (const form of forms) {
    if (formUtils[form.ref]) {
      formUtils[form.ref] = new FormUtils(form);
    }
  }
};
